<div class="offer-overview">
  <table *ngIf="offers.length > 0" aria-label="List of offers" mat-table
         [dataSource]="selectedOffer== null ? offers : [selectedOffer]" class="offers-table"
         [class.single-offer]="selectedOffer != null"
         cdkDropList
         [cdkDropListData]="offers"
         (cdkDropListDropped)="drop($event)">

    <ng-container matColumnDef="bookmarked">
      <th mat-header-cell *matHeaderCellDef> Gemerkt</th>
      <td mat-cell *matCellDef="let offer">
        <img *ngIf="offer.bookmarked" src="../../../assets/svg-icons/starFilled.svg" alt="bookmarked">
        <img *ngIf="!offer.bookmarked" src="../../../assets/svg-icons/starEmpty.svg" alt="not bookmarked">
      </td>
    </ng-container>

    <ng-container matColumnDef="offer-read" *ngIf="offersReadByUserIds$ | async as readOffers">
      <th mat-header-cell *matHeaderCellDef class="text-start"></th>
      <td mat-cell class="text-start" *matCellDef="let offer">
        <div>
          <span [ngClass]="isOfferRead(offer.offerId, proposalId, readOffers, offer.creator.id) ? 'transparent-dot' : 'blue-dot'"></span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="text-start"> {{'offer.status'|translate}}</th>
      <td mat-cell class="text-start" *matCellDef="let offer">
        <div *ngIf="offer.status.toLowerCase() !== OfferStatus.OPEN && offer.offerType !== OfferType.FIXED"  >
          <span class="offer-status-container" [style.background-color]="OfferStatusColors[offer.status]"
            [class.accepted]="offer.status.toLowerCase() == OfferStatus.ACCEPTED">
            {{'offer.' + offer.status.toLowerCase() |translate}}
          </span>
        </div>
        <div *ngIf="offer.offerType === OfferType.EXTERNAL_COVERAGE" class="offer-status-container external">
          <span>
            {{'offer.extern' |translate}}
          </span>
        </div>
        <div *ngIf="offer.offerType === OfferType.FIXED" class="offer-status-container external">
          <span>
            {{'offer.fixed' |translate}}
          </span>
        </div>
        <div *ngIf="offer.status.toLowerCase() === OfferStatus.OPEN && offer.offerType !== OfferType.EXTERNAL_COVERAGE" class="offer-status-container external">
          <span>
            {{'offer.open' |translate}}
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="lastTimeEdited">
      <th mat-header-cell *matHeaderCellDef class="text-start" aria-label=""></th>
      <td mat-cell class="text-start" *matCellDef="let offer">
        <span *ngIf="offer.lastTimeEdited != null" class="offer-lastTimeEdited-container" >
          {{'offer.lastTimeEdited' | translate}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="creator" *ngIf="offersReadByUserIds$ | async as readOffers">
      <th mat-header-cell *matHeaderCellDef class="text-start"> {{'offer.offerCreator'|translate}}</th>
      <td mat-cell class="text-start" *matCellDef="let offer">
        <div *ngIf="offer.offerType != OfferType.EXTERNAL_COVERAGE && offer.offerType !== OfferType.FIXED"
             class="d-flex all-cursor-pointer user-pod"
             (click)="navigateToUserProfile(offer.creator.id)">
          <img class="custom-profile-picture me-2 rounded-circle"
               [src]="(userService.getProfilePicture(offer.creator.id) |async) ?? 'assets/img/profile/default-profile-icon.png'"
               alt="private"/>

          <div class="d-flex flex-column justify-content-center">
            <span
              class="light-text small-text creator-label"
              [ngClass]="{'highlighted_text': !isOfferRead(offer.offerId, this.proposalId, readOffers, offer.creator.id)}">
              {{offer.creator.firstName}} {{offer.creator.lastName}}
            </span>

            <a [routerLink]="'/'+ Route.COMPANY_PROFILE+'/'+ offer.creator.company.companyId"
               class="dark-text small-text company-label"
               [ngClass]="{'highlighted_text': !isOfferRead(offer.offerId, this.proposalId, readOffers, offer.creator.id)}">
              {{offer.creator.company.name}}
            </a>
          </div>
        </div>
        <div *ngIf="offer.offerType === OfferType.FIXED"
             class="d-flex">
          <div class="d-flex flex-column justify-content-center">
            <span
              class="light-text small-text creator-label">
              {{'offer.fixedCreated'|translate}}
            </span>
          </div>
        </div>
        <div *ngIf="offer.offerType === OfferType.EXTERNAL_COVERAGE && offersReadByUserIds$ | async as readOffers" class="d-flex external">
          <div class="custom-profile-picture me-2 rounded-circle">{{'offer.ex'|translate}}</div>
          <span class="dark-text small-text"
                [ngClass]="{'highlighted_text': !isOfferRead(offer.offerId, this.proposalId, readOffers, offer.creator.id)}"
          >{{offer.externalInsurer.name}}</span>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="premium" *ngIf="offersReadByUserIds$ | async as readOffers">
      <th mat-header-cell *matHeaderCellDef class="text-end"> {{'offer.expectedTotalPremiumWithoutSupercript'|translate}}</th>

      <td mat-cell class="text-end" *matCellDef="let offer">
        <div *ngIf="offer.offerType !== OfferType.REJECTION && offer.offerType !== OfferType.FIXED"
             [ngClass]="{'highlighted_text': !isOfferRead(offer.offerId, this.proposalId, readOffers, offer.creator.id)}"
        >
          {{offer.premium |currency:offer.currency}}
          ({{ offer.premium / insuredAmount |percentFormat}})
        </div>
        <div *ngIf="offer.offerType === OfferType.REJECTION"></div>
      </td>

    </ng-container>
    <ng-container matColumnDef="share" *ngIf="offersReadByUserIds$ | async as readOffers">
      <th mat-header-cell *matHeaderCellDef class="text-end"> {{'offer.coverageShare'|translate}}</th>
      <td mat-cell class="text-end" *matCellDef="let offer">
        <div *ngIf="offer.offerType !== OfferType.REJECTION"
             [ngClass]="{'highlighted_text': !isOfferRead(offer.offerId, this.proposalId, readOffers, offer.creator.id)}"
        >
          {{NumberParseService.convertToPercentageDisplay(offer.amountCovered, 2)}}
        </div>
        <div *ngIf="offer.offerType === OfferType.REJECTION"></div>
      </td>
    </ng-container>
    <ng-container matColumnDef="role" *ngIf="offersReadByUserIds$ | async as readOffers">
      <th mat-header-cell *matHeaderCellDef class="text-start"> {{'offer.role'|translate}}</th>

      <td mat-cell class="text-start" *matCellDef="let offer">
        <div *ngIf="offer.offerType !== OfferType.REJECTION && offer.offerType !== OfferType.FIXED"
             [ngClass]="{'highlighted_text': !isOfferRead(offer.offerId, this.proposalId, readOffers, offer.creator.id)}"
        >{{'offer.' + getRole(offer)|translate}}</div>
        <div *ngIf="offer.offerType === OfferType.REJECTION"></div>
      </td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let offer">
        <mat-icon class="main-blue cursor-pointer" *ngIf="offer.offerType !== OfferType.REJECTION && offer.offerType !== OfferType.FIXED"
                  (click)="selectOffer(offer)">
          arrow_forward
        </mat-icon>
        <img [ngbPopover]="rejectionReason"
             placement="start"
             *ngIf="offer.offerType === OfferType.REJECTION && offer.rejectionText !== null"

             class="details-button cursor-pointer" alt="" src="assets/svg-icons/speaker-notes.svg">
        <ng-template #rejectionReason>
          <ng-scrollbar visibility="hover">
            <div class="rejection-popover-body" style="max-height: 16rem">
              <span class="reject-popover-label">{{'offer.rejectionReason.label'| translate}} </span>
              <span class="reject-popover-reason">{{offer.rejectionText}}</span>
            </div>
          </ng-scrollbar>
        </ng-template>
      </td>

    </ng-container>
    <tr [hidden]="selectedOffer != null" mat-header-row *matHeaderRowDef="displayedColumns; sticky: false"></tr>
    <ng-container>
      <tr mat-row
        *matRowDef="let row; columns: (selectedOffer == null ? displayedColumns: displayedColumns.slice(0, displayedColumns.length-1));"
        cdkDrag
        [cdkDragData]="row"
        [cdkDragDisabled]="(proposalUserId$|async) != (activeUserId$|async)"
        cdkDragLockAxis="y">
      </tr>
    </ng-container>


  </table>
  <!--  Add space so the popover is not hidden by overflow-->

</div>
